import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Typography, Box, Paper, CircularProgress } from '@mui/material';
import { purple } from '@mui/material/colors';
import axios from 'axios';

function ResetPassword() {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getBasicAuthHeader = () => {
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;
    const encodedCredentials = btoa(`${username}:${password}`);
    return `Basic ${encodedCredentials}`;
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError(false);
  };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleResetPassword = async () => {
    if (!validateEmail(email)) {
      setEmailError(true);
      return;
    }
  
    setLoading(true);
  
    try {
      const body = { email:email };
      const apiUrl2 = process.env.REACT_APP_API_URL;
  
      const response = await axios.post(
        `${apiUrl2}/api/user/request-reset`,
        body,
        {
          headers: {
            'Authorization': getBasicAuthHeader(),
          },
        }
      );
      //console.log(response.data);
      //console.log(response.data.secret);
      const secret = response.data.secret;
      //console.log(secret)
      navigate('/verify-otp', { state: { secret, email } });
    } catch (error) {
      console.error('Error resetting password:', error);
      navigate('/error', { state: { message: 'User does not exist.' } });
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Container maxWidth="sm" style={{ height: '52vh', display: 'flex', alignItems: 'center' }}>
      <Paper elevation={3} style={{ padding: '2em', width: '100%' }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="h4" gutterBottom style={{ color: purple[500], marginBottom: '1em' }}>
            Reset Password
          </Typography>
          <TextField
            label="Email Address"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={handleEmailChange}
            error={emailError}
            helperText={emailError ? 'Please enter a valid email address' : ''}
          />
          <Button
            variant="contained"
            fullWidth
            onClick={handleResetPassword}
            disabled={loading}
            style={{ backgroundColor: purple[500], color: 'white', marginTop: '1em' }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Reset Password'}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default ResetPassword;
